import { useSelector } from "react-redux";
import { ExtractFnReturnType, QueryConfig } from "../../../lib/react-query";
import { getHistoricClaims } from "../api/ClaimAPI";
import { RootState } from "../../../redux/store";
import { PaginationFilterDto } from "../../../types/Pagination";
import { useQuery } from "@tanstack/react-query";

type QueryFnType = typeof getHistoricClaims;

type UseGetHistoricClaims = {
    config?: QueryConfig<QueryFnType>;
};

export const useGetHistoricClaims = ({config}: UseGetHistoricClaims = {}) => {
    const selectedFilters = useSelector((state: RootState) => state.filters.claims.selectedFilters);
    const pagination = useSelector((state: RootState) => state.historical.claim);
    const filterByCurrentUser = useSelector((state: RootState) => state.filters.claims.filterByCurrentUser);
    const currentUser = useSelector((state: RootState) => state.currentUserInfo.data);

    const paginationFilters: PaginationFilterDto =
    {
        pageNumber: pagination.currentPage,
        pageSize: pagination.itemsPerPage,
        search: pagination.searchText,
        filterByCurrentUser,
        filters: selectedFilters,
        selectedOrganizationalStructureIds: currentUser.selectedOrganizationalStructureIds
    };

    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        retry: false,
        queryKey: ['getHistoricClaims', selectedFilters, pagination, filterByCurrentUser, currentUser],
        queryFn: () => getHistoricClaims(paginationFilters),
    });
}
